import { Component, OnInit, Input } from '@angular/core'
import { EventsService } from '../../services/events.service'
import { MessagesDelegate } from '../../services/messages-delegate.service'

import * as moment from 'moment'
moment.locale('fr')

import { Event } from '../../models/event.model'

@Component({
  selector: 'ld-events-list',
  template: require('./events-list.component.html'),
  styles: [require('./events-list.component.css')]
})
export class EventsListComponent implements OnInit {
  @Input('events') events: Event[]
  @Input('currentMoment') currentMoment = moment()
  @Input('currentYear') currentYear = moment().year()

  constructor (
    private eventsService: EventsService,
    private messagesDelegate: MessagesDelegate) {}

  async ngOnInit () {
    if (typeof this.events !== 'undefined') return

    this.events = await this.eventsService.getAll()
      .catch(() => {
        this.messagesDelegate.add('APP.EVENTSLIST.ERROR')
        return []
      })
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/components/events-list/events-list.component.ts